import "core-js/modules/es.array.concat";
import "core-js/modules/es.number.constructor";
import { __awaiter, __generator, __read, __spread } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      gift: null,
      invite: {
        list: [],
        loaded: false,
        requesting: false
      },
      stat: null,
      top10: null,
      stat13: null,
      monitorInviteRank: {},
      dreamInvitePrize: {}
    };
  },
  mutations: {
    setGift: function setGift(state, gift) {
      state.gift = gift;
    },
    concatList: function concatList(state, list) {
      var _a;

      (_a = state.invite.list).push.apply(_a, __spread(list));
    },
    setListLoaded: function setListLoaded(state, loaded) {
      state.invite.loaded = loaded;
    },
    setListReq: function setListReq(state, req) {
      state.invite.requesting = req;
    },
    setStat: function setStat(state, stat) {
      state.stat = stat;
    },
    setTop10: function setTop10(state, top10) {
      state.top10 = top10;
    },
    setStat13: function setStat13(state, stat) {
      state.stat13 = stat;
    },

    /** 队长邀请排行榜 */
    initMonitorInviteRank: function initMonitorInviteRank(state, _a) {
      var key = _a.key;
      Vue.set(state.monitorInviteRank, key, {
        list: [],
        loaded: false,
        requesting: false
      });
    },
    concatMonitorInviteRank: function concatMonitorInviteRank(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.monitorInviteRank[key].list = state.monitorInviteRank[key].list.concat(list);
    },
    setMonitorInviteRankLoaded: function setMonitorInviteRankLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.monitorInviteRank[key].loaded = loaded;
    },
    setMonitorInviteRankReq: function setMonitorInviteRankReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.monitorInviteRank[key].requesting = req;
    },

    /** 追梦中国邀请奖金列表 */
    initDreamInvitePrize: function initDreamInvitePrize(state, _a) {
      var key = _a.key;
      Vue.set(state.dreamInvitePrize, key, {
        list: [],
        loaded: false,
        requesting: false
      });
    },
    concatDreamInvitePrize: function concatDreamInvitePrize(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.dreamInvitePrize[key].list = state.dreamInvitePrize[key].list.concat(list);
    },
    setDreamInvitePrizeLoaded: function setDreamInvitePrizeLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.dreamInvitePrize[key].loaded = loaded;
    },
    setDreamInvitePrizeReq: function setDreamInvitePrizeReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.dreamInvitePrize[key].requesting = req;
    }
  },
  actions: {
    /**
     * 获得礼品
     */
    getGift: function getGift(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/gift_list', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setGift', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得邀请列表
     */
    getList: function getList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          lastId = _b.lastId,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.invite.requesting || state.invite.loaded) {
                return [2
                /*return*/
                ];
              }

              commit('setListReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/list', {
                params: {
                  id: activityId,
                  last_id: lastId,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatList', list);

                if (list.length < count) {
                  commit('setListLoaded', true);
                }
              }

              commit('setListReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取邀请统计
     */
    getStat: function getStat(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/stats', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setStat', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getTop10: function getTop10(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/top_10', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTop10', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取邀请第13届百日跑
     */
    getStat13: function getStat13(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (state.stat13 && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/activity_invite_stat', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setStat13', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提交领取13届礼品的请求
     */
    chooseActivityGift13: function chooseActivityGift13(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          giftId = _b.giftId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/invite/choose_activity_gift', {
                activity_id: activityId,
                id: giftId
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 队长邀请排行榜
     */
    getMonitorInviteRank: function getMonitorInviteRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = activityId;
              wrap = state.monitorInviteRank[key];

              if (!wrap || offset === 0 && forceUpdate) {
                commit('initMonitorInviteRank', {
                  key: key
                });
                wrap = state.monitorInviteRank[key];
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setMonitorInviteRankReq', {
                key: key,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/monitor_invite_rank', {
                params: {
                  id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data.list;
                commit('concatMonitorInviteRank', {
                  key: key,
                  list: list
                });

                if (list.length < count) {
                  commit('setMonitorInviteRankLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              commit('setMonitorInviteRankReq', {
                key: key,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 追梦中国个人邀请列表
     */
    getInvitePrizeList: function getInvitePrizeList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = Number(activityId);
              wrap = state.dreamInvitePrize[key];

              if (!wrap || offset === 0 && forceUpdate) {
                commit('initDreamInvitePrize', {
                  key: key
                });
                wrap = state.dreamInvitePrize[key];
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setDreamInvitePrizeReq', {
                key: key,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/prize', {
                params: {
                  activity_id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatDreamInvitePrize', {
                  key: key,
                  list: list
                });

                if (list.length < count) {
                  commit('setDreamInvitePrizeLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              commit('setDreamInvitePrizeReq', {
                key: key,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    // 领取礼品
    receiveGift: function receiveGift(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/invite/receive_gift', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;